import { render } from "./MyPageRequestList.vue?vue&type=template&id=33012cf2&scoped=true"
import script from "./MyPageRequestList.vue?vue&type=script&lang=js"
export * from "./MyPageRequestList.vue?vue&type=script&lang=js"

import "./MyPageRequestList.vue?vue&type=style&index=0&id=33012cf2&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33012cf2"]])

export default __exports__